import { useTranslation } from 'react-i18next';
import React from 'react';
import Typography from '@src/new-components/Typography';
import DropdownCustom from '@src/new-components/Dropdown';
import { COLOR } from '@src/styles/color';

const Accent = ({ handleChangeFilter, dataFilter }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const currentAccent = dataFilter?.language?.regions?.find(
    (region) => region?.regionSubTag === dataFilter?.region,
  );

  const regions = dataFilter?.language?.regions?.filter(
    (region) => region?.regionSubTag,
  );
  const disabled =
    regions?.length > 0 ? !regions.every((region) => region?.name?.vi) : true;

  return (
    <div style={{ flex: 1 }}>
      <DropdownCustom
        variant="language-voice-mobile"
        options={
          dataFilter?.language?.regions?.map((region) => ({
            label: region?.name?.[language],
            value: region?.regionSubTag,
          })) || []
        }
        onChange={(value) => handleChangeFilter('region', value)}
        title={
          <Typography
            variant="body-14-medium"
            color={
              dataFilter?.region
                ? COLOR.descriptionGray
                : COLOR.descriptionUpload
            }
          >
            {currentAccent
              ? t(currentAccent?.name?.[language])
              : t('chooseLanguage')}
          </Typography>
        }
        value={dataFilter?.region}
        disabled={disabled}
      />
    </div>
  );
};

export default Accent;
